export const LEG_FORM_CONFIG = {
  validations: {
    orderNumber: {
      required: { value: true, message: "Order Number is required" },
    },
  },
};
